import React, { useState } from 'react';
import { TextField, MenuItem, Button, Typography, Box } from '@mui/material';

const defaultObs = { name: '',
  rr: '', spo2: '', sbp: '', pulse: '', temp: '', avpu: '', air: true, o2: '', device: ''
};

const presets = {
  '15L O₂': { air: false, o2: '15L', device: 'NRM' },
  'Shock': { sbp: 80, pulse: 130, temp: 35.2, rr: 28, avpu: 'P', spo2: 88 },
  'Tachycardia (hypo)': { pulse: 140, sbp: 85, rr: 26 },
  'Tachycardia (normo)': { pulse: 140, sbp: 125, rr: 24 }
};

export default function ScenarioObs({ data = [], onChange }) {
  const [obs, setObs] = useState({ ...defaultObs });
  const handleChange = (field, value) => setObs({ ...obs, [field]: value });

  const handleSave = () => {
    const newEntry = {
      ...obs
    };

    const updated = [...data, newEntry];
    onChange && onChange(updated);

    // Reset for next entry
    setObs({ ...defaultObs });
    console.log(obs)
  };

  return (
    <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
    <div style={{padding: '2rem', paddingTop:'0px' }}>
      <div style={{display:'flex', textAlign:'center', marginBottom:'1rem', paddingTop:'5px', borderBottom:'1px solid lightgrey', paddingBottom:'5px'}}>
        <Typography>Observations saved here can be sent to the participant during the live scenario. Facilitators can also create and send observations sets during the scenario if required.</Typography>
      </div>
      <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
        <div style={{display:'flex', flexDirection:'column', width:'50%', marginBottom:'-2rem'}}>
          <div style={{display:'flex', flexDirection:'row', gap:'1rem', alignItems:'center'}}>
              <TextField
                label="Observations set name"
                type="text"
                value={obs.name}
                onChange={(e) => handleChange('name', e.target.value)}
                slotProps={{ textField: { margin: 'normal' } }}
              />
            <Button variant="contained" color="primary" onClick={handleSave} style={{height:'40px', alignSelf:'center'}} disabled={obs.name===""}>
              Save Obs
            </Button>
          </div>

          <div style={{display:'flex', flexDirection:'row', gap:'5px', marginBottom:'-1rem'}}>
            <TextField
              label="RR"
              type="number"
              value={obs.rr}
              onChange={(e) => handleChange('rr', e.target.value)}
              margin="normal"
            />
            <TextField
              label="Sats (%)"
              type="number"
              value={obs.spo2}
              onChange={(e) => handleChange('spo2', e.target.value)}
              margin="normal"
            />
            <TextField
              label="O₂ Flow"
              value={obs.o2}
              onChange={(e) => handleChange('o2', e.target.value)}
              margin="normal"
            />
            <TextField
              label="O₂ Device"
              value={obs.device}
              onChange={(e) => handleChange('device', e.target.value)}
              margin="normal"
            />
            </div>

          <div style={{display:'flex', flexDirection:'row', gap:'5px', marginBottom:'-1rem'}}>
            <TextField
              label="SBP (mmHg)"
              type="number"
              value={obs.sbp}
              onChange={(e) => handleChange('sbp', e.target.value)}
              margin="normal"
            />
            <TextField
              label="Pulse"
              type="number"
              value={obs.pulse}
              onChange={(e) => handleChange('pulse', e.target.value)}
              margin="normal"
            />
          </div>
          
          <div style={{display:'flex', flexDirection:'row', gap:'5px'}}>
            <TextField
              label="AVPU"
              select
              value={obs.avpu}
              onChange={(e) => handleChange('avpu', e.target.value)}
              margin="normal"
              style={{minWidth:'120px'}}
            >
              {['Alert', 'V', 'P', 'U'].map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
            <TextField
              label="Temp"
              type="number"
              value={obs.temp}
              onChange={(e) => handleChange('temp', e.target.value)}
              margin="normal"
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
